import React from 'react';

const testimonialsData = [
  {
    id: 1,
    quote: "Be Safe Keep Safe transformed our workplace safety culture. Their comprehensive inspections and professional advice helped us achieve full compliance while creating a safer environment for our employees.",
    name: "Sarah Johnson",
    role: "Operations Manager",
    company: "Manufacturing Solutions Ltd",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&h=150&auto=format&fit=crop"
  },
  {
    id: 2,
    quote: "The team's expertise in agricultural safety is outstanding. They provided practical solutions that were easy to implement and significantly improved our safety standards across all operations.",
    name: "Michael Chen",
    role: "Farm Director",
    company: "Agricultural Enterprises",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=150&h=150&auto=format&fit=crop"
  },
  {
    id: 3,
    quote: "Their construction and fire safety expertise is exceptional. The zoom consultations were incredibly convenient and the advice was always practical and actionable.",
    name: "Emma Williams",
    role: "Safety Coordinator",
    company: "Construction Group PLC",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&h=150&auto=format&fit=crop"
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <div className="section-badge">Testimonials</div>
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">
            Hear from businesses who have transformed their safety culture with our expert guidance
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonialsData.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="card-content">
                <div className="quote-icon">"</div>
                <p className="testimonial-quote">{testimonial.quote}</p>
                <div className="testimonial-stars">
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                </div>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <img src={testimonial.avatar} alt={testimonial.name} />
                </div>
                <div className="author-info">
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-role">{testimonial.role}</p>
                  <p className="author-company">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
